import { Link as RouterLink, type LinkProps as RouterLinkProps } from "@tanstack/react-router";
import {
  Button,
  Typography,
  Link as MuiLink,
  type ButtonProps,
  type LinkProps as MuiLinkProps,
} from "@mui/material";

type BaseProps = {
  button?: boolean;
  activeClassName?: string;
};

export type MuiRouterLinkProps = BaseProps &
  Omit<MuiLinkProps, "href"> &
  Omit<ButtonProps, "href"> &
  RouterLinkProps;

export function Link(props: MuiRouterLinkProps) {
  const { to, params, search, hash, button, activeClassName = "active", children, ...rest } = props;

  const isExternal =
    typeof to === "string" && (to.startsWith("http://") || to.startsWith("https://"));

  if (isExternal) {
    return button ? (
      <Button component="a" href={to as string} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </Button>
    ) : (
      <MuiLink href={to as string} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </MuiLink>
    );
  }

  const Component: React.ElementType = button ? Button : Typography;

  return (
    <RouterLink
      to={to}
      params={params}
      search={search}
      style={{
        textDecoration: "none",
      }}
      hash={hash}
      activeProps={{
        className: activeClassName,
      }}
      {...rest}
    >
      <Component {...rest} className={`${rest.className ?? ""} ${activeClassName ?? ""}`}>
        {children}
      </Component>
    </RouterLink>
  );
}
